import 'whatwg-fetch'
import { setLoading, setFinished, setInitial } from './LoadingButton'

export default () => {
  const forms = document.querySelectorAll('.js-form')

  if (forms) {
    ;[...forms].forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault()

        const button = form.querySelector('.c-button')

        setLoading(button) // Set button to loading

        if (!form.checkValidity()) return

        sendForm(form)
          .then(handleFetch)
          .then(r => {
            if (r.error) {
              setInitial(button)
              return
            }
            setFinished(button)
            sendGTAEvent(form)
            setTimeout(() => {
              window.location = r.action
              setInitial(button)
              resetForm(form)
            }, 1000)
          })
          .catch(e => {
            console.error(e)
            setInitial(button)
            window.alert(
              'Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.'
            )
          })
      })
    })
  }

  function sendGTAEvent(form) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'formSent',
      form:
        form.querySelector("input[name='form_title']") !== undefined &&
        form.querySelector("input[name='form_title']") !== null
          ? form.querySelector("input[name='form_title']").value
          : 'Onbekend'
    })
  }

  const sendForm = form =>
    window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(form)
    })

  const resetForm = form => form.reset()

  const handleFetch = r => {
    if (!r.ok) {
      const error = {
        error:
          'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      }
      return error
    } else {
      return r.json()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js